import React from 'react';
import InstagramPanel from '../../../../../InstagramConfig/components/InstagramPanel';

const InstagramDetail = ({ agentId }) => {
  return (
    <div style={{ padding: '1rem' }}>
      <InstagramPanel agentId={agentId} />
    </div>
  );
};

export default InstagramDetail;
